/* @jsx h */
import { defineComponent, h } from "vue";
import { useRouter } from "vue-router";
import { LoginFormComponent } from "@app/vue/components/AuthComponents";

export const LoginPage = defineComponent({
  name: "LoginPage",
  setup: function () {
    const router = useRouter();
    return () => {
      return (
        <LoginFormComponent
          onSuccess={() => {
            console.log("succesded", router);
            router.push("/");
          }}
        />
      );
    };
  },
});
